import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CartController from '@/components/cart-controller';
import styles from './container.module.css';
import { useEffect, useState } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const QueryClientSideProvider = ({ children }: { children: React.ReactNode }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const renderChildren = (
    <div className={styles.container} id="main-content">
      {children}
    </div>
  );

  return (
    <>
      {isClient ? (
        <QueryClientProvider client={queryClient}>
          <CartController>{renderChildren}</CartController>
        </QueryClientProvider>
      ) : (
        <>{renderChildren}</>
      )}
    </>
  );
};
